export const JOHN_DEERE_TREE_API = '/api/john-deere/organizations';
